import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';
import { useState, useContext } from 'react';
import { UserContext } from '@/context/user';
import { setUserContextItem, removeUserContextItem } from '@/persistence/user_context';

import { Button, Input } from 'antd';
import { ButtonQuestion } from '@/components/button/question';
import { sendEvent } from '@/utils/ga';

export const PageLogin = () => {
  const [id, setId] = useState('')

  const {
    userId,
    setUserId
  } = useContext(UserContext)

  const onIdChange = (e: any) => {
    const value = e.target.value
    setId(value)
  }

  const onLoginClick = (e: React.MouseEvent) => {
    e.preventDefault()

    removeUserContextItem({ key: 'user_id' })
    setUserContextItem({ key: 'user_id', value: id })

    setUserId(id)

    alert(`안녕하세요! ${id}님!`)

    sendEvent('login', {
      method: 'google'
    })

    setTimeout(() => {
      window.location.reload()
    }, 400)
  }

  const onLogoutClick = (e: React.MouseEvent) => {
    e.preventDefault()

    removeUserContextItem({ key: 'user_id' })
    setUserId(undefined)

    alert(`다음에 또 오세요!`)

    setTimeout(() => {
      window.location.reload()
    }, 400)
  }

  if (userId) {
    return (
      <>
        <Helmet>
          <title>로그아웃</title>
        </Helmet>
        <div className={styles.header}>
          <h2>로그아웃</h2>
        </div>
        <div className={styles.contents}>
          <div className={styles.rowInput}>
            <div className={styles.colLeft}>아이디</div>
            <div className={styles.colRight}>
              <Input value={userId.id} disabled={true} placeholder="현재 로그인 아이디"/>
            </div>
          </div>
          <hr className={styles.divider} />
          <div className={styles.rowActions}>
            <div className={styles.colBtnSignUp}>
              <Button style={{width: '140px'}} type="primary" size="large" onClick={(e) => onLogoutClick(e)}>로그아웃</Button>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Helmet>
        <title>로그인</title>
      </Helmet>
      <div className={styles.header}>
        <h2>로그인</h2>
      </div>
      <div className={styles.contents}>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>아이디</div>
          <div className={styles.colRight}>
            <Input onChange={(e) => onIdChange(e) } placeholder="아이디를 입력해주세요"/>
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.rowActions}>
          <div className={styles.colBtnSignUp}>
            <Button style={{width: '140px'}} disabled={id === ''} type="primary" size="large" onClick={(e) => onLoginClick(e)}>구글로 로그인</Button>
            <ButtonQuestion
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'login', {
  method: 'google'
})
`
                )
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}